import React, { useCallback } from "react";

import Form, { FormProps } from "antd/es/form";

import { useConfigProvider } from "../../../ConfigProvider";
import FormItem from "../../../FormItem";
import TextField from "../../../input/TextField";
import Modal from "../../../Modal";

import styles from "./LinkModal.module.scss";
import UrlFormItem from "./UrlFormItem";

interface FormValues {
  text: string;
  url: string;
}

interface LinkModalProps {
  initialText?: string;
  initialUrl?: string;
  onHide?: () => void;
  onOk?: (text: string, url: string) => void;
}

const LinkModal = ({ initialText, initialUrl, onHide, onOk }: LinkModalProps) => {
  const configProvider = useConfigProvider();

  const [form] = Form.useForm<FormValues>();

  const handleOk = useCallback(() => {
    form.submit();
  }, [form]);

  const handleFormFinish = useCallback<NonNullable<FormProps<FormValues>["onFinish"]>>(
    (values) => {
      onOk?.(values.text || values.url, values.url);
    },
    [onOk]
  );

  return (
    <Modal
      cancelButtonProps={{ hidden: true }}
      okText={configProvider.formatMessage("ui.emailBody.linkModal.okay")}
      onCancel={onHide}
      onOk={handleOk}
      open
      title={configProvider.formatMessage("ui.emailBody.linkModal.title")}
    >
      <div className={styles.container}>
        <Form
          form={form}
          initialValues={{ text: initialText, url: initialUrl }}
          layout="vertical"
          onFinish={handleFormFinish}
        >
          <FormItem name="text">
            <TextField
              label={configProvider.formatMessage("ui.emailBody.linkModal.linkText")}
              placeholder={configProvider.formatMessage("ui.emailBody.linkModal.linkText")}
            />
          </FormItem>
          <UrlFormItem required />
        </Form>
      </div>
    </Modal>
  );
};

export default LinkModal;
